// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + "reactTeaserList01" + "." + "3068e72f" + ".chunk.css";
};